import { useMutation } from "react-query";
import {
  VehicleOneTimePremiumRequestParams,
  deleteVehicleOneTimePremium,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const deleteVehicleOneTimePremiumFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleOneTimePremiumRequestParams;
}) => {
  return await deleteVehicleOneTimePremium(rowVersion, params);
};

export function useDeleteVehicleOneTimePremium() {
  return useMutation(deleteVehicleOneTimePremiumFn, {
    mutationKey: MUTATION_KEYS.deleteVehicleOneTimePremium,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
